import { useCustomerIOContext } from '@aibees/shared/context';

export const useCustomerIO = <T extends string>() => {
  const { customerio } = useCustomerIOContext();

  return {
    identify: customerio?.identifyUser.bind(customerio),
    track: customerio?.trackEvent.bind(customerio),
    trackPageView: customerio?.trackPageView.bind(customerio),
    updateUser: customerio?.updateUser.bind(customerio),
    reset: customerio?.resetUser.bind(customerio),
    getUserId: customerio?.getUserId.bind(customerio),
  };
};
